module.exports = __webpack_public_path__ + "img/no-content.5fd1676a.png";